import React from "react";
import logo from "../../../../../../app/assets/images/Illustration.svg";
import { Button } from "antd";

import "./SurveyConfirmation.scss";

const SurveyConfirmation = ({ isSurveySubmitted = false, surveySubmittedSuccessfully = "" }) => {
   const reloadPage = () => {
      window.location.reload();
   };

   return (
      <div className="survey-confirmation">
         <div className="confirmation-content">
            <div className="left-part">
               <img src={logo} alt="Girl working on laptop" className="illustration" />
            </div>
            <div className="right-part">
               {surveySubmittedSuccessfully === "multi-use" ? (
                  <>
                     <h1>Thank you for completing the survey!</h1>
                     <h2>Click below to start a new one</h2>
                     <Button type="primary" className="kapSurveyPrimaryButton" onClick={reloadPage}>
                        New response
                     </Button>
                  </>
               ) : surveySubmittedSuccessfully === "multi-use-kiosk" ? (
                  <>
                     <h1 className="heading-kiosk-mode">Thank you for submitting!</h1>
                     <h2>This survey will reset shortly for the next person...</h2>
                  </>
               ) : isSurveySubmitted ? (
                  <h1>You have already submitted this survey!</h1>
               ) : (
                  <>
                     <h1>Thank you for completing the survey!</h1>
                     <h2>Your responses have been submitted</h2>
                  </>
               )}
               {surveySubmittedSuccessfully !== "multi-use-kiosk" && (
                  <p className="info-email-description">
                     If you submitted by mistake, please email us at{" "}
                     <a href="mailto:info@kaptechgroup.com">info@kaptechgroup.com</a> for
                     assistance.
                  </p>
               )}
            </div>
         </div>
      </div>
   );
};

export default SurveyConfirmation;
